import { Category } from "@/store/slices/storeSlice";
import { useEffect, useState } from "react";
import { NavLink as Link, useNavigate } from "react-router-dom";
import { isTeacher } from "../../hooks/utils";
import { useAppSelector } from "../../store/hooks";
import Animation from "../Animation";
import Spinner from "../Spinner";
import { Button } from "../ui/button";
import CategoryCard from "./CategoryCard";

const SchoolGrades = ({
  grades,
  title,
  parts,
}: {
  grades?: Category[];
  title?: string;
  parts?: string[];
}) => {
  const pathname =
    parts.length > 1 && parts[0] !== ""
      ? parts?.join("/")
      : window.location.pathname;
  const [isMobile, setIsMobile] = useState(false);
  const { currentTeacher, portal } = useAppSelector((state) => state.store);
  const navigate = useNavigate();

  const getGrades = () => {
    if (!portal) return [];

    // handle the ew approach for dynamic category routing so return the categories to be displayed
    if (grades) return grades;

    return portal.cats
      .filter((cat) => cat.parent === 0)
      .sort((a, b) => Number(a.order) - Number(b.order));
  };

  useEffect(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    setIsMobile(
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      )
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentTeacher]);

  return (
    <Animation>
      <div className="min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {title || "الأقسام الرئيسية"}
            </h1>
          </div>

          {!portal && (
            <div className="flex items-center justify-center w-full py-10">
              <Spinner />
            </div>
          )}

          {portal?.cats?.length > 0 && (
            <>
              {getGrades().length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {getGrades().map((grade) => (
                    <Link
                      key={grade.term_taxonomy_id}
                      to={
                        parts?.[0] !== ""
                          ? `/${parts?.join("/")}/${grade.slug}`
                          : `/${grade.slug}`
                      }
                    >
                      <CategoryCard title={grade?.name} />
                    </Link>
                  ))}
                </div>
              ) : isTeacher() ? (
                <div className="text-center text-lg w-full flex items-center justify-center gap-3">
                  <span className="text-(--primary-color) font-medium">
                    إنشئ أول مرحلة دراسية
                  </span>
                  <Button
                    onClick={() => navigate("/dashboard/manage-categories")}
                  >
                    من هنا
                  </Button>
                </div>
              ) : (
                <h3 className="font-semibold text-2xl">
                  لا يوجد مراحل دراسية متاحة
                </h3>
              )}
            </>
          )}
        </div>
      </div>
    </Animation>
  );
};

export default SchoolGrades;

// import { useEffect, useState } from "react";
// import { NavLink as Link, useNavigate } from "react-router-dom";
// // import { gsap } from "gsap";
// // import useAuth from "../../hooks/useAuth";
// import { isTeacher } from "../../hooks/utils";
// import { useAppSelector } from "../../store/hooks";
// import Animation from "../Animation";
// import Spinner from "../Spinner";

// const SchoolGrades = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const { currentTeacher, portal } = useAppSelector((state) => state.store);
//   const navigate = useNavigate();

//   const getCatsFromPortal = () => {
//     if (!portal) return [];
//     console.log({
//       portalll: portal.cats.filter((item) => item.parent === 0),
//       portal: portal,
//     });
//     const cats = portal.cats.filter((item) => item.parent === 0);

//     const sortedCats = cats.sort((a, b) => Number(a.order) - Number(b.order));
//     return sortedCats;
//   };

//   useEffect(() => {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     setIsMobile(
//       /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//         userAgent
//       )
//     );
//   }, [currentTeacher]);

//   return (
//     <Animation>
//       <div className="teachers">
//         <p className="h1 text-ea-primary fw-bold mt-3 mb-2 text-center">
//           المرحلة الدراسية
//         </p>
//         {!portal && <Spinner />}
//         {portal?.cats?.length > 0 && (
//           <Animation>
//             <div
//               className="row responsive-padding-card rounded-ea mx-auto"
//               style={{
//                 width: "80%",
//               }}
//             >
//               {portal && getCatsFromPortal().length > 0 ? (
//                 <>
//                   {getCatsFromPortal().map((item) => (
//                     <div
//                       className="col-sm-6 col-md-4 col-lg-3 mb-4"
//                       key={item.term_taxonomy_id}
//                     >
//                       <div
//                         className="card shadow w-100 rounded-ea bg-ea border-0"
//                         style={{ width: "18rem" }}
//                       >
//                         <Link
//                           style={{
//                             textDecoration: "none",
//                           }}
//                           to={{
//                             pathname: `/${item.slug}/groups`,
//                             state: { teacherData: item },
//                           }}
//                         >
//                           <div className="teacher-card px-3 py-2">
//                             {portal?.cardImg && (
//                               <img
//                                 src={decodeURIComponent(portal.cardImg)}
//                                 className="card-img-top my-2 bg-white"
//                                 alt={
//                                   item.term_name?.split("|")[1] ?? portal.name
//                                 }
//                               />
//                             )}
//                             <p className="teacher-name">
//                               {item.name?.indexOf("|") > -1
//                                 ? item.name?.split("|")[0]
//                                 : item.name}
//                             </p>
//                           </div>
//                         </Link>
//                       </div>
//                     </div>
//                   ))}
//                 </>
//               ) : isTeacher() ? (
//                 <button
//                   className="rounded-ea mt-5 mx-auto w-25 mw-90"
//                   onClick={() => navigate("/dashboard/manage-categories")}
//                 >
//                   إنشئ أول مرحلة دراسية
//                 </button>
//               ) : (
//                 <></>
//               )}
//             </div>
//           </Animation>
//         )}
//       </div>
//     </Animation>
//   );
// };

// export default SchoolGrades;
